import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import CompleteState from './complete_state';
import Error from './error';
import InitialState from './initial_state';
import Progress from './progress';
import { get } from 'helpers/api';

import './styles.scss';

export default class FileArchiver extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    path: PropTypes.string.isRequired,
  }

  state = {}

  getUrl = () => {
    this.setState({ preparing: true, failed: false });

    get(this.props.path)
      .then(this.handleSuccess)
      .catch(this.handleError);
  }

  handleSuccess = ({ preparedRecordCount, recordCount, url }) => {
    if (url) {
      this.setState({ preparing: false, url });
      window.location.assign(url);
    } else {
      this.setState({ preparedRecordCount, recordCount });
      setTimeout(this.getUrl, 1000);
    }
  }

  handleError = () => {
    this.setState({ failed: true });
  }

  render() {
    return (
      <div className={classNames('file-archiver', this.props.className)}>
        {this.renderContent()}
      </div>
    );
  }

  renderContent() {
    if (this.state.failed) {
      return <Error onClick={this.getUrl} />;
    } else if (this.state.url) {
      return <CompleteState url={this.state.url} />;
    } else if (this.state.preparing) {
      return <Progress preparedRecordCount={this.state.preparedRecordCount} recordCount={this.state.recordCount} />;
    } else {
      return <InitialState onClick={this.getUrl} />;
    }
  }
}
